<template>
  <v-card>
    <v-card-title>
      <h2 style="font-size: 21px">
        {{ isEditing ? 'Editar Pasta' : 'Adicionar Pasta' }}
      </h2>
    </v-card-title>
    <v-card-text>
      <v-form ref="form">
        <label class="label">Nome da pasta</label>
        <v-text-field
          placeholder="Nome da pasta"
          class="primary-input"
          outlined
          hide-details="auto"
          v-model="folder.name"
          :rules="[(v) => !!v || 'Nome da pasta é obrigatória']"
          required
        ></v-text-field>
        <label class="label">Pasta</label>
        <v-select
          placeholder="Selecione a pasta"
          class="primary-input"
          :disabled="!!parentFolderId"
          outlined
          hide-details="auto"
          v-model="folder.folderId"
          append-icon="mdi-chevron-down"
          :items="folders"
          item-text="name"
          item-value="id"
        ></v-select>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn class="primary-button ma-1 mb-4" depressed @click="$emit('close')">
        Cancelar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        class="secondary-button ma-1 mb-4"
        depressed
        :loading="loading"
        @click="submit"
      >
        {{ isEditing ? 'Atualizar' : 'Adicionar' }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'

export default {
  name: 'PopsFolderModal',

  props: {
    folderId: Number,
    parentFolderId: Number,
    engType: Number,
  },

  created() {
    if (this.folderId) {
      this.isEditing = true
      this.getFolder()
    }
    this.getAllFolders()

    if (this.parentFolderId) this.folder.folderId = this.parentFolderId
    this.folder.engType = this.engType
  },

  data() {
    return {
      isEditing: false,
      loading: false,
      folder: {},
      folders: [],
      apiService: new ApiService(),
    }
  },

  methods: {
    async getAllFolders() {
      try {
        const response = await this.apiService.get(
          `PopDocumentFolder/list-clinic`
        )
        this.folders = response.content.filter((x) => x.id != this.folderId)
      } catch (error) {
        console.log(error)
        console.error('Erro ao carregar pastas.')
      }
    },

    getFolder() {
      if (!this.folderId) return

      this.loading = true
      this.apiService
        .get(`PopDocumentFolder/${this.folderId}`)
        .then((response) => {
          this.folder = response.content
          this.folder.engType = this.engType
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    submit() {
      if (this.isEditing) this.edit()
      else this.add()
    },

    async edit() {
      if (!this.$refs.form.validate()) return

      await this.apiService
        .put(`PopDocumentFolder/`, this.folder)
        .then(async () => {
          this.$toast.success('Pasta editada com sucesso!')
          this.$emit('success')
        })
    },

    async add() {
      if (!this.$refs.form.validate()) return
      this.folder.engType = 0
      await this.apiService
        .post('PopDocumentFolder/add', this.folder)
        .then(async () => {
          this.$toast.success('Pasta criada com sucesso!')
          this.$emit('success')
        })
    },
  },
}
</script>

<style></style>
